export const ARCHIVE_SEARCH_FIELDS = [
  { value: 'auftragsnummer', label: 'Auftrag' },
  { value: 'vertragsnummer', label: 'Vertrag' },
  { value: 'externeId', label: 'Event' },
  { value: 'externerName', label: 'Event Name' },
  { value: 'dokumentTyp', label: 'Dokument' },
  { value: 'errorMessage', label: 'Fehler' },
  { value: 'unterdrueckung', label: 'Unterdrückung' },
] as const;

export type ArchiveSearchField =
  (typeof ARCHIVE_SEARCH_FIELDS)[number]['value'];
export const ALL_ARCHIVE_SEARCH_FIELDS = ARCHIVE_SEARCH_FIELDS.map(
  ({ value }) => value,
);

// Restore older or malformed saved settings without permitting an empty search scope.
export function normalizeArchiveSearchFields(
  value: unknown,
): ArchiveSearchField[] {
  if (!Array.isArray(value)) return [...ALL_ARCHIVE_SEARCH_FIELDS];
  const fields = ALL_ARCHIVE_SEARCH_FIELDS.filter((field) =>
    value.includes(field),
  );
  return fields.length ? fields : [...ALL_ARCHIVE_SEARCH_FIELDS];
}
